import { c as _c } from "react/compiler-runtime";
import { palette } from '@cc-shopping/ui/theme';
import { Box, List, ListItem, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import AuthorCard from 'src/shared/content/Author/AuthorCard';
import { useReviewContext } from '../../Context';
import { ReviewsLinkedData } from './ReviewsLinkedData';
export default function ReviewAuthorsDetails() {
  const $ = _c(12);
  const review = useReviewContext();
  const {
    authors
  } = review;
  if (authors.length === 0) {
    return null;
  }
  const t0 = authors.length > 1 && "s";
  let t1;
  if ($[0] !== t0) {
    t1 = <Box borderBottom={`1px solid ${palette.grey[200]}`} pb={1} mb={3}><Typography component="h2" variant="textLarge">About the author{t0}</Typography></Box>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== authors) {
    t2 = authors.map(_temp);
    $[2] = authors;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <List>{t2}</List>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== review) {
    t4 = <ReviewsLinkedData id="reviews-linked-data" review={review} />;
    $[6] = review;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
    t5 = <Grid mb={10} size={12} data-testid="bottomAuthorComp">{t1}{t3}{t4}</Grid>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(author) {
  return <ListItem key={author.id}><AuthorCard author={author} avatar={author.image} fromReview={true} /></ListItem>;
}